var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIlsFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.281 45.12H-2.173V0H62.28v45.12Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.281 10.152H-2.173V4.23H62.28v5.922Zm0 30.888H-2.173v-5.922H62.28v5.922ZM19.717 16.805 29.42 33.69l9.913-16.805-19.616-.07v-.01Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.595 28.006 1.842 3.129 1.886-3.111-3.737-.018h.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.682 28.253 9.711-16.885 9.905 16.814-19.616.07Z",
    fill: "#0038B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.595 16.885 1.842-3.129 1.886 3.12-3.736.009h.008Zm-3.86 7.006-1.912 3.172 3.613-.009-1.7-3.172v.009Zm-1.877-5.86 3.631.026-1.745 3.199-1.886-3.226Zm13.325 5.904 1.842 3.128-3.675-.044 1.833-3.084Zm1.807-5.905-3.631.027 1.745 3.199 1.886-3.226Zm-10.073 0-2.503 4.53 2.538 4.433 4.653.106 2.82-4.539-2.608-4.582-4.9.044v.008Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h60v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlsFlag);
export default __webpack_public_path__ + "static/media/ils-flag.daafc010c370cd90c8ab015e7a43212a.svg";
export { ForwardRef as ReactComponent };